module.exports = __webpack_public_path__ + "static/media/star-active.4443c49f.svg";